export const formatVoyage = (voyageNum: string): string => `v.${voyageNum}`;

export const getStatusColor = (status: string | null): string => {
  const str = status
    ? status.charAt(0).toUpperCase() + status.slice(1).toLowerCase()
    : "";
  switch (str) {
    case "In progress":
      return "#FF8C00";
    case "Docked":
      return "#90EE90";
    case "Cancelled":
      return "red";
    case "Closed":
      return "#4CAF50";
    case "Inbound":
      return "#9FA8DA";
    case "Outbound":
      return "#DCE775";
    case "Shifting":
      return "purple";
    case "Shiftingdown":
      return "blue";
    case "At sea":
      return "#FF9800"; // Darker orange
    case "Upcoming":
      return "#C3FDFF";
    case "Anchored":
      return "#81D4FA";
    case "OUTGOING":
      return "#F4A400"; // Keep this as is (it's already distinct)
    case "Completed":
      return "green";
    case "Along Side":
      return "blue";
    case "Pending optc":
      return "#808080";
    case "Pending final port log":
      return "#A88C60";
    default:
      return "gray";
  }
};

export const getActivityColor = (etd: string) => {
  try {
    const etdDate = new Date(etd);
    const now = new Date();
    const timeDifference =
      (etdDate.getTime() - now.getTime()) / (1000 * 60 * 60);
    // console.log(etdDate.getTime(), etdDate);
    if (etdDate < now) {
      // console.log(etdDate);
      return {
        bgColor: "#f5f5f5",
      };
    }
    if (timeDifference > 2 && timeDifference <= 6) {
      return {
        border: "#f5e431", // Yellow (unchanged)
      };
    }
    if (timeDifference <= 2) {
      return {
        border: "#FF8C00", // Darker orange
      };
    }

    return {};
  } catch {
    return {};
  }
};

export const getBerthTypeColor = (type: string): string => {
  switch (type) {
    case "Loading":
      return "steelblue";
    case "Discharging":
      return "#FF8C00"; // Darker orange
    default:
      return "#81d4fa";
  }
};

export const getContrastColor = (bgColor: string | null) => {
  if (!bgColor) {
    return "#000000"; // Default to black if bgColor is null or undefined
  }
  // Convert hex to RGB
  const hex = bgColor.replace("#", "");
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);

  // Calculate luminance
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

  // Return white for dark bg and black for light bg
  return luminance > 0.5 ? "#000000" : "#FFFFFF";
};

export const getPositionColorCode = (role: string) => {
  try {
    switch (role.toLowerCase()) {
      case "agent":
        return "#d1f7c4";
      case "surveyor":
        return "#0B76B7";
      case "vendor":
        return "#444444";
      case "port captain":
        return "#2750AE";
      case "hub agent - mol":
        return "#FCB400";
      case "owner":
        return "#D1F7C4";
      case "operations":
        return "#F82B60";
      case "vessel":
        return "#EEEEEE";
      case "guard shack":
        return "#EDE2FE";
      case "point of contact":
        return "#FFDAF6";
      case "pilot":
        return "#9FA8DA";
      case "tpoc":
        return "#CFDFFF";
      case "portauth":
        return "#D0F0FD";
      case "tugs":
        return "#FFEAB6";
      case "lines":
        return "#FEE2D5";
      default:
        return "initial"; // Default color if no match
    }
  } catch {
    return "initial";
  }
};

export const getEmailStatusColorCode = (value: string) => {
  switch (value) {
    case "Success":
      return "#239B56";
    case "Error":
      return "#FF0000";
    case "Warning":
      return "#FFAE42";
    default:
      return "#239B56";
  }
};

export const getPortCallingsShorthand = (portCallings: string | string[]) => {
  try {
    if (!portCallings) return "";
    const callings = (
      Array.isArray(portCallings)
        ? portCallings
        : String(portCallings).split(",")
    )
      .map((c) => (c == null ? "" : String(c).trim()))
      .filter(Boolean)
      .sort((a, b) => a.localeCompare(b)) // sort before mapping to initials
      .map((val) => {
        const city = val.split(",")[0].trim();
        return city
          .split(/\s+/)
          .filter(Boolean)
          .map((w) => w[0].toUpperCase())
          .join("");
      })
      .filter(Boolean);
    return callings.join(", ");
  } catch (error) {
    console.error("Error getting port callings shorthand:", error);
    return "";
  }
};

export const getOrdinal = (num: number): string => {
  const j = num % 10;
  const k = num % 100;

  if (k >= 11 && k <= 13) {
    return `${num}th`;
  }

  switch (j) {
    case 1:
      return `${num}st`;
    case 2:
      return `${num}nd`;
    case 3:
      return `${num}rd`;
    default:
      return `${num}th`;
  }
};
